/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Date from './Date/index'
import React from 'react'
import Time from './Time/index'
import TysiaTag from 'DesignSystem/TysiaTag/index'
import TysiaTagText from 'DesignSystem/TysiaTag/TysiaTagText/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Content/Home/AppointmentBookings/Content/BookingDetails/DateTimeMissed/Content"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<Date
  viewPath={`${viewPath}/Date`}
/>
<Time
  viewPath={`${viewPath}/Time`}
/>
<TysiaTag
  viewPath={`${viewPath}/TysiaTag`}
 marginLeft={dtSpaceXs}
 type="red"
>
{childProps => (
<TysiaTagText
{...childProps}
  viewPath={`${viewPath}/TysiaTagText`}
 text="Missed"
/>
)}
</TysiaTag>
{children}
</React.Fragment>)
}